import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useCamera } from '../../hooks/useCamera';
import { currentStatesState } from '../../storage/client';
import { initialCenteringState } from '../../storage/map';

function ClientCameraProvider() {
  const currentStates = useRecoilValue(currentStatesState);
  const [initialCentering, setInitialCentering] = useRecoilState(initialCenteringState);
  const { fitToLngLats } = useCamera();
  const { map } = useMap();

  useEffect(() => {
    if (initialCentering) {
      if (!map || !currentStates) return;
      const points = currentStates
        .map((currentState) => {
          const point = [currentState.position_longitude, currentState.position_latitude];
          const isValidPoint = isValidLatitude(point[1]) && isValidLongitude(point[0]);
          if (!isValidPoint) return [0, 0];
          return point;
        })
        .filter((point) => point[0] !== 0 && point[1] !== 0);
      fitToLngLats(points);
      setInitialCentering(false);
    }
  }, [currentStates, map, fitToLngLats]);

  return null;
}

export default ClientCameraProvider;
